const o = "popover", p = "popover__panel", e = "popover__content", _ = "popover__footer", t = {
  popover: o,
  popover__panel: p,
  popover__content: e,
  popover__footer: _
};
export {
  t as default,
  o as popover,
  e as popover__content,
  _ as popover__footer,
  p as popover__panel
};
